module.exports = __webpack_public_path__ + "img/switch.ce707ba1.svg";